const defaultOptions = {
  shortFormat: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  },
  longFormat: {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  },
};

function convert(value, format) {
  return new Date(value).toLocaleDateString('lv-LV', format);
}

function msToTime(duration) {
  let minutes = parseInt((duration / (1000 * 60)) % 60, 10);
  let hours = parseInt(duration / (1000 * 60 * 60), 10);

  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${hours}h:${minutes}m`;
}

const date = {
  short: (value, format = {}) => convert(value, { ...defaultOptions.shortFormat, ...format }),
  long: (value, format = {}) => convert(value, { ...defaultOptions.longFormat, ...format }),
  duration: value => msToTime(value),
};

export default date;



// WEBPACK FOOTER //
// ./src/utils/date.js